export interface BulkRouteActionByFiltersArgs {
  readonly organizationUuid: string
  readonly applicationUuid: string
  readonly filters: {
    readonly filterText: string
    readonly quickFilter: string
    readonly startDate?: number
    readonly endDate?: number
    readonly agentSessionId?: string[]
  }
  readonly excludedHashes: string[]
}

export const buildUrlParamsFromFilters = (
  filters: BulkRouteActionByFiltersArgs['filters']
) =>
  Object.keys(filters)
    .filter((key) =>
      // Exclude startDate and endDate when they are falsy since they can be undefined
      (key === 'endDate' || key === 'startDate') && !filters[key] ? false : true
    )
    .map((key) => `${key}=${filters[key]}`)
    .join('&')
